<div class="main">
  <div class="d-flex flex-column gap-1">

    <div class="btn mb-2 static-button text-light">
      <i class="bi bi-circle-fill" [ngClass]="colorToMove === 'White' ? 'text-light' : 'text-black'"></i> {{ colorToMove }} to move
    </div>

    @if (!puzzleEnded) {
      <button (click)="showHint.emit()" class="btn btn-outline-primary">
        <i class="bi bi-lightbulb"></i>
        Show hint
      </button>
    }
    @if (puzzleEnded) {
      <button (click)="openPuzzleFenInLichess()" class="btn btn-outline-primary mb-2">
        <i class="bi bi-diagram-3-fill me-2"></i>
        Analyse position
      </button>

      <button (click)="goToNextPuzzle.emit()" class="btn btn-success">
        <i class="bi bi-arrow-right-circle-fill me-2"></i>
        Next puzzle
      </button>
    }
  </div>
</div>
